import { SortDirectionToggler } from './SortDirectionToggler';

export const components = {
  SortDirectionToggler,
};
